import gql from 'graphql-tag';

export default gql`
  mutation AddManualActivity($input: DailyTrackerAddManualActivityInputType!) {
    dailyTracker {
      addManualActivity(input: $input) {
        ... on DailyTrackerAddManualActivitySuccess {
          activity {
            id
            name
            sourceType
            activityType
            activityTypeName
            caloriesBurned
            durationSeconds
            loggedAt
            distance
            distanceUnit
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
      }
    }
  }
`;
